<div>
  <div class="cooking-header">
    <div class="title">
      <img src="assets/cookingbook/users.svg" alt="" />

      <p>عضویت در خانه</p>
    </div>
    <img src="assets/cookingbook/angle-down.svg" (click)="goBack()" alt="" />
  </div>
  <div class="cooking-body">
    <p class="invite-title">آیا مطمئن به عضویت در این خانه هستید؟</p>
    <div class="buttons">
      <div class="accept" (click)="accept()">بله</div>
      <div class="reject" (click)="goBack()">خیر</div>
    </div>
  </div>
</div>
